import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';
import './theme/darkMode.css';

// Prevent horizontal scrolling globally
const globalStyles = `
  * {
    box-sizing: border-box;
  }
  
  html, body {
    overflow-x: hidden;
    max-width: 100vw;
    margin: 0;
    padding: 0;
  }
  
  #root {
    overflow-x: hidden;
    max-width: 100vw;
  }
`;

// Inject global styles
const styleSheet = document.createElement('style');
styleSheet.textContent = globalStyles;
document.head.appendChild(styleSheet);
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import { StepsProvider } from './Context';
import { store } from './store';
import { Provider } from 'react-redux';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <HelmetProvider>
    <SidebarProvider>
      {/* <BrowserRouter basename="/appcontrol" future={{ v7_startTransition: true, v7_relativeSplatPath: true }}> */}
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>

        <StepsProvider>
          <Provider store={store}>
            <App />
          </Provider>
        </StepsProvider>
      </BrowserRouter>
    </SidebarProvider>
  </HelmetProvider>
);
